import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetVendorCreditDetailsQuery } from "../../../services/Reports";
import {
  getVendorCreditDetailsRequest,
  getVendorCreditDetailsFailure,
  getVendorCreditDetailsSuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allVendorCreditDetails,
    isLoading: vendorCreditDetailsLoading,
    isError: vendorCreditDetailsError,
  } = useGetVendorCreditDetailsQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.vendorCreditDetailsPageNo,
    pageSize: state.vendorCreditDetailsPageSize,
    fromDate: new Date(state.vendorCreditDetailsFromDate).toLocaleDateString(),
    toDate: new Date(state.vendorCreditDetailsToDate).toLocaleDateString(),
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (vendorCreditDetailsLoading) {
      dispatch(getVendorCreditDetailsRequest());
    }
    if (vendorCreditDetailsError) {
      dispatch(getVendorCreditDetailsFailure(vendorCreditDetailsError));
    }
    if (allVendorCreditDetails) {
      dispatch(
        getVendorCreditDetailsSuccess({
          data: allVendorCreditDetails.data.vendorCreditData[0].data || [],
          totalPages:
            allVendorCreditDetails.data.vendorCreditData[0].metadata[0]
              ?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allVendorCreditDetails,
    profileData,
    state.vendorCreditDetailsFromDate,
    state.vendorCreditDetailsToDate,
    state.vendorCreditDetailsPageNo,
    state.vendorCreditDetailsPageSize,
  ]);
  return <></>;
};
export default Content;
